import { InfoCircle } from '@untitledui/icons';

import { cx } from '@/utils/cx';

interface OneWayBannerProps {
  className?: string;
}

/**
 * Persistent info banner explaining that Salesforce sync is currently
 * one-way (Salesforce → Ahoy). Not a warning — this is expected, ongoing
 * behavior, so it uses info/utility-blue styling rather than error/warning
 * tokens.
 */
export function OneWayBanner({ className }: OneWayBannerProps) {
  return (
    <div
      className={cx(
        'flex items-start gap-2.5 rounded-lg border border-utility-blue-200 bg-utility-blue-50 px-3.5 py-2.5',
        className
      )}
    >
      <InfoCircle
        className='mt-0.5 size-4 shrink-0 text-utility-blue-700'
        aria-hidden='true'
      />
      <p className='text-body-small text-utility-blue-700'>
        Sync from Salesforce is one-way for now — changes made in Ahoy won’t be
        sent to Salesforce yet.
      </p>
    </div>
  );
}
